export const removeEmptyPTags = (input: string) => {
  const withoutLeadingPTags = input.replace(/^<p>\s*<\/p>/, '');

  const withoutTrailingPTags = withoutLeadingPTags.replace(/<p>\s*<\/p>$/, '');

  const finalResult = withoutTrailingPTags.replace(/^<p>\s*<\/p>/, '');

  return finalResult;
};
